import { Injectable } from '@angular/core';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root',
})
export class customDeviceStylings {
  csDesktopWidth = this.breakpointService.getSize(BREAKPOINT.lg);
  constructor(private deviceService: DeviceDetectorService, private breakpointService: BreakpointService) {}

  isTabletMaxWidthExceeds(): boolean {
    if (
      this.deviceService.isTablet() &&
      window.innerWidth > this.csDesktopWidth &&
      window.outerWidth < window.outerHeight
    ) {
      return true;
    } else {
      return false;
    }
  }
}
